import { render, staticRenderFns } from "./index-alive.vue?vue&type=template&id=6773bf74"
import script from "./index-alive.vue?vue&type=script&lang=js"
export * from "./index-alive.vue?vue&type=script&lang=js"
import style0 from "./index-alive.vue?vue&type=style&index=0&id=6773bf74&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports